<nz-spin [nzSpinning]="loading$ | async">
  <form nz-form [formGroup]="form" nzLayout="vertical">
    <nz-form-item>
      <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="agentId" nzRequired>
        {{ 'ADD_CAR_INSPECTION.AGENT' | translate }}
      </nz-form-label>
      <nz-form-control nzErrorTip="{{ 'ACTIONS.FIELD_REQUIRED' | translate }}">
        <app-lot-add-car-inspection-admin-form-modal-agent
          formControlName="agentId"
        ></app-lot-add-car-inspection-admin-form-modal-agent>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-label [nzSm]="8" [nzXs]="24" nzFor="comment">
        {{ 'ADD_CAR_INSPECTION.COMMENT' | translate }}
      </nz-form-label>
      <nz-form-control [nzErrorTip]="commentErrorsTxt">
        <nz-textarea-count
          [nzMaxCharacterCount]="commentLimit"
          [nzComputeCharacterCount]="computeLength"
        >
          <textarea
            nz-input
            formControlName="comment"
            [rows]="4"
            [placeholder]="'ADD_CAR_INSPECTION.COMMENT' | translate"
          ></textarea>
        </nz-textarea-count>
      </nz-form-control>
    </nz-form-item>
  </form>
  <ng-template #commentErrorsTxt let-control>
    <ng-container *ngIf="control.hasError('maxlength')">
      {{ 'ADD_CAR_INSPECTION.WARNING_COMMENT' | translate }}
    </ng-container>
  </ng-template>
</nz-spin>

<ng-container *nzModalFooter>
  <button
    nz-button
    nzType="primary"
    [disabled]="form.invalid"
    [nzLoading]="creating$ | async"
    (click)="createRequest()"
  >
    {{ 'SEND' | translate }}
  </button>
  <button nz-button (click)="close()">
    {{ 'CANCEL' | translate }}
  </button>
</ng-container>
